import { Modal, Form, Input, Select, message } from "antd";
import { useCreateExpenseCategory } from "@/pages/Expenses/ManageExpense/hooks/useExpenseCategories";
import { useGetExpenseTypesOptions } from "@/pages/Expenses/ManageExpense/hooks/useExpenseTypes";
import { useEffect } from "react";
import { SelectOption } from "@/types/select";

interface CreateModalFormValues {
  name: string;
  expense_type_id: string;
}

interface CreateModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
}

const CreateModal = ({ isOpen, onClose, onSuccess }: CreateModalProps) => {
  const [form] = Form.useForm();
  const { mutate: createExpenseCategory, isPending } =
    useCreateExpenseCategory();
  const { data: expenseTypes } = useGetExpenseTypesOptions();

  const handleSubmit = async (values: CreateModalFormValues) => {
    createExpenseCategory(values, {
      onSuccess: () => {
        message.success("Successfully created expense category");
        form.resetFields();
        onClose?.();
        onSuccess?.();
      },
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose?.();
  };

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  const expenseTypeOptions: SelectOption[] = (expenseTypes || [])
    .filter((type) => type.is_active)
    .map((type) => ({
      label: type.name,
      value: type.id,
    }));

  return (
    <Modal
      title="New Category"
      open={isOpen}
      onCancel={handleCancel}
      width={600}
      confirmLoading={isPending}
      onOk={form.submit}
      okText="Create"
      destroyOnHidden
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="expense_type_id"
          label="Expense Type"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Select expense type"
            options={expenseTypeOptions}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateModal;
